import './MemberTierCard.css';
import type { MemberPortalDto, MemberCardAppearance } from '@pokerroom/types';
import type { MemberPreferences } from './member-preferences';
import { useTranslation } from 'react-i18next';
export function MemberTierCard({
  member,
  appearance,
  preferences,
  open,
  labels,
  logos,
}: {
  member: MemberPortalDto;
  appearance?: MemberCardAppearance;
  preferences: MemberPreferences;
  open: () => void;
  labels?: { showQr: string; cardImage: string };
  logos?: { light: string; dark: string };
}) {
  const { t } = useTranslation();
  const tier = member.level.visualTier ?? 'unknown';
  const visible = appearance?.showLevelName ?? true;
  const z = tier === 'z' && visible;
  const white = tier === 'vip' || tier === 'black' || (z && preferences.theme === 'dark');
  const logo = white ? (logos?.dark ?? '/zipa-mark-white.png') : (logos?.light ?? '/zipa-mark.png');
  const watermark = preferences.cardStyle === 'watermark';
  const words = {
    standard: 'CLASSIC',
    vip: 'VIP',
    black: 'BLACK',
    z: 'Z',
    unknown: member.level.name,
  };
  const count = { standard: 1, vip: 2, black: 3, z: 4, unknown: 0 }[tier];
  return (
    <button
      className="tier-card"
      data-member-theme={preferences.theme}
      data-tier={tier}
      data-style={preferences.cardStyle}
      data-z={z || undefined}
      onClick={open}
      aria-label={labels?.showQr ?? t('showQr')}
    >
      {appearance?.imageUrl ? (
        <img
          className="tier-custom"
          src={appearance.imageUrl}
          alt={labels?.cardImage ?? t('會員卡卡面')}
        />
      ) : (
        <>
          {watermark && <img className="tier-watermark" src={logo} alt="" />}
          {z ? (
            <>
              {!watermark && <div className="z-glow" />}
              <span className="z-glyph">Z</span>
              {!watermark && <img className="z-logo" src={logo} alt="ZIPA POKER" />}
            </>
          ) : (
            <div className="tier-brand">
              {!watermark && <img src={logo} alt="" />}
              <div className="tier-wordmark">
                <span>ZIPA POKER</span>
                {visible && (
                  <div className="tier-level">
                    <strong>{words[tier]}</strong>
                    {count > 0 && (
                      <span className="tier-pips" aria-hidden="true">
                        {Array.from({ length: 4 }, (_, i) => (
                          <i key={i} className={i < count ? 'filled' : ''} />
                        ))}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="tier-identity">
            <span>{member.displayName}</span>
            <span>{member.memberNo}</span>
          </div>
        </>
      )}
      {member.level.expiresAt && (
        <span className="tier-expiry">
          {t('levelValidUntil', {
            time: new Intl.DateTimeFormat('sv-SE', {
              timeZone: 'Asia/Taipei',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              hourCycle: 'h23',
            }).format(new Date(member.level.expiresAt)),
          })}
        </span>
      )}
    </button>
  );
}
